import {
  QUEST_CLOSE,
  QUEST_COMPLETE,
  QUEST_ITEM_COMPLETE,
  QUEST_START
} from '../../constants/QuestConstants'
import { getUserId } from '../../utils/authLocalStorage'
import { logEvent } from '../../utils/firebase'

const keyQuest = 'keyquest'
const keyQuestItems = 'keyquestitems'
const keyIntroQuest = 'keyintroquest'

export const items = [
  {
    complete: false,
    id: 'save_design',
    tag: 'savedesign',
    title: 'Play Design Games and Earn Rewards',
    desc: ''
  },
  {
    complete: false,
    id: 'share_design',
    tag: 'sharedesign',
    title: 'Decorate Real Rooms',
    desc: ''
  },
  {
    complete: false,
    id: 'get_app',
    tag: 'getapp',
    title: 'Host Your Own Project Events',
    desc: ''
  }
]

export const getQuest = id => {
  if (typeof window === 'undefined') return false

  const userId = getUserId()
  return Boolean(localStorage.getItem(keyQuest + userId))
}

export const getQuestItems = id => {
  if (typeof window === 'undefined') return false

  const userId = getUserId()
  const questItems = JSON.parse(localStorage.getItem(keyQuestItems + userId))
  if (questItems === null) return items
  return questItems
}

export const setIntroQuest = userId => {
  if (typeof window === 'undefined') return false

  //localStorage.removeItem(keyIntroQuest)
  const intro = localStorage.getItem(keyIntroQuest + userId)

  if (intro === 'false') return false
  else {
    localStorage.setItem(keyIntroQuest + userId, true)
    return true
  }
}

export const newQuest = userId => {
  if (typeof window === 'undefined') return false

  const haveIntro = localStorage.getItem(keyIntroQuest + userId)
  // console.log(haveIntro === false, haveIntro === 'false')
  if (haveIntro === 'false') return false

  logEvent('quest', {
    content_type: 'intro',
    content_id: 0,
    value: 'start'
  })

  const tag = 'quest_introstart_viewed'
  logEvent(tag)

  localStorage.setItem(keyQuest + userId, true)
  setQuestData(userId)
}

export const setQuestData = userId => {
  localStorage.setItem(
    keyQuestItems + userId,
    JSON.stringify(getQuestItems(userId))
  )
}

export const completeQuestItem = (index, userId) => {
  const items = JSON.parse(localStorage.getItem(keyQuestItems + userId))
  items[index].complete = true
  localStorage.setItem(keyQuestItems + userId, JSON.stringify(items))

  logEvent('quest', {
    content_type: 'intro',
    content_id: 0,
    value: items[index].id
  })

  const tag = 'quest_intro' + items[index].id + '_viewed'
  logEvent(tag)
}

export const checkQuestProgress = userId => {
  const items = JSON.parse(localStorage.getItem(keyQuestItems + userId))
  var count = 0
  for (const item of items) {
    if (Boolean(item.complete) === true) count++
  }
  if (count === items.length) return true
  return false
}

export const removeQuest = userId => {
  if (typeof window === 'undefined') return false

  localStorage.setItem(keyIntroQuest + userId, false)
  localStorage.removeItem(keyQuest + userId)
  localStorage.removeItem(keyQuestItems + userId)
}

export const startQuest = userId => dispatch => {
  newQuest(userId)
  dispatch({ type: QUEST_START, items: getQuestItems(userId) })
}

export const updateQuest = index => (dispatch, state) => {
  const userId =
    state().auth.user &&
    state().auth.user.puser &&
    state().auth.user.puser.objectId
      ? state().auth.user.puser.objectId
      : false
  if (userId === false) return
  if (typeof index === 'undefined') {
    return
  }
  // console.log(userId, getQuest(userId))
  if (!getQuest(userId)) {
    return
  }

  completeQuestItem(index, userId)

  const isComplete = checkQuestProgress(userId)

  if (isComplete === false) {
    dispatch({ type: QUEST_ITEM_COMPLETE, items: getQuestItems(userId) })
  } else {
    dispatch(endQuest(userId))
  }
}

export const endQuest = userId => dispatch => {
  logEvent('quest', {
    content_type: 'intro',
    content_id: 0,
    value: 'end'
  })

  const tag = 'quest_introend_viewed'
  logEvent(tag)

  removeQuest(userId)
  dispatch({ type: QUEST_COMPLETE })
}

export const closeQuest = () => dispatch => {
  dispatch({ type: QUEST_CLOSE })
}
